<template>
<span class='caption text-center'><center>
  <span @click='reload' class='black--text' > AppointmentGuru version: {{version}}</span>
  <v-btn
    v-show='reloadRequired'
    small success
    style='position:fixed; top: 5px; right:5px;z-index:10'
    @click='reload' >Update available. Please reload</v-btn>
  <v-btn v-if='withReload' @click='reload' small flat block >Get latest version</v-btn>
  </center>
</span>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Version',
  props: {
    withReload: { type: Boolean, default: true }
  },
  data () {
    return {
      version: null,
      latestVersion: null,
      reloadRequired: false
    }
  },
  mounted () {
    this.getVersion()
    setInterval(this.getVersion, 300000)
  },
  methods: {
    getVersion () {
      // get from localStorage
      if (localStorage && localStorage.getItem('version')) {
        this.version = localStorage.getItem('version')
      }
      this.$emit('input', this.version)
      axios.get('/static/about.json')
       .then((result) => {
         let latestVersion = result.data.version
         if (latestVersion !== this.version) {
           caches.keys().then((keys) => { for (let key of keys) { caches.delete(key) } })
           localStorage.setItem('version', latestVersion)
           if (this.version) { this.reloadRequired = true }
           this.version = latestVersion
           // window.location.reload()
         }
       })
    },
    reload () {
      window.location.reload()
    }
  }
}
// caches.keys().then((keys) => { for (key of keys) { caches.delete(key) } })
// window.location.reload()
</script>

<style>

</style>



// WEBPACK FOOTER //
// Version.vue?7288c112